import { render, staticRenderFns } from "./FilesPage.vue?vue&type=template&id=32a9f3e7&scoped=true"
import script from "./FilesPage.vue?vue&type=script&lang=js"
export * from "./FilesPage.vue?vue&type=script&lang=js"
import style0 from "./FilesPage.vue?vue&type=style&index=0&id=32a9f3e7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a9f3e7",
  null
  
)

export default component.exports